/*
 * Please read this before changing this variable, higher precision from Groot cause multiple errors
 * in the operations we perform with the cooordinates.
 * https://gis.stackexchange.com/questions/8650/measuring-accuracy-of-latitude-and-longitude/8674#8674
 */
const PRECISION = 8;

const roundPair = subject => [Number(subject[0].toFixed(PRECISION)), Number(subject[1].toFixed(PRECISION))];

const roundRing = coordinates => coordinates.map(roundPair);

const roundPolygon = coordinates => coordinates.map(roundRing);

const roundMultyPolygon = coordinates => coordinates.map(roundPolygon);

/*
 * Rounds the coordinates of a GEOJSON in to an specific number of decimals.
 * @param {Object} geometry
 * @return {Object} the rounded geometry
 */
export const roundGeometry = geometry => {
  const { type, coordinates: coord } = geometry;
  let coordinates = [];
  switch (type) {
    case 'MultiPolygon':
      coordinates = roundMultyPolygon(coord);
      break;
    case 'Polygon':
      coordinates = roundPolygon(coord);
      break;
    default:
      return [];
  }
  return {...geometry, coordinates};
};

export const roundFeature = feature => {
  return { ...feature, geometry: roundGeometry(feature.geometry)};
};

/*
 * Rounds the coordinates of a script in to an specific number of decimals.
 * @param {Object} script
 * @return {Object} the rounded script
 */
export const roundScript = script => {
  return {...script, geometry: {...script.geometry, features: script.geometry.features.map(roundFeature)}};
};
